<template>
  <el-tooltip effect="dark" :content="value" :disabled="disabled" placement="bottom">
    <!--  @mouseenter="mouseenter" @mouseleave="mouseleave" -->
    <div class="vue-text" ref="text" :style="textStyle">
      {{ value }}
    </div>
  </el-tooltip>
</template>

<script>
export default {
  // 显示文字组件，可以设置最多显示几行，超过后会隐藏并且鼠标hover显示全部信息（需要给组件设置宽度）
  name: "dg-text",
  props: {
    value: {
      type: String,
      default: "",
    },
    row: {
      //最多显示几行，超过后会...隐藏 为0时不隐藏
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    text() {
      return this.$refs.text;
    },
  },
  data() {
    return {
      textStyle: {},
      div: null,
      disabled: false,
    };
  },
  watch: {
    value: {
      handler() {
        this.disabled = false;
        this.textStyle = {
          cursor: "text",
        };
        this.$nextTick(() => {
          this.getStyle(this.row - 0);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getStyle(val) {
      let lineHeight = getComputedStyle(this.text).lineHeight.replace("px", "") - 0 || 20;
      let height = getComputedStyle(this.text).height.replace("px", "") - 0;
      if (height > lineHeight * val) {
        this.disabled = false;
        this.textStyle = {
          height: `${lineHeight * val}px`,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          webkitLineClamp: val,
          webkitBoxOrient: "vertical",
          cursor: "pointer",
        };
      } else {
        this.disabled = true;
        this.textStyle = {
          cursor: "text",
        };
      }
    },
  },
};
</script>

<style lang="css"></style>